export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5576.1ac4fda0.jpg";